<template>
  <guest-layout>
    <template v-slot:header>
      <div class="row">
        <div class="col-4">
          <img
            width="800"
            height="630"
            class="img-fluid"
            src="/assets/img/logos/logo_horizontal.png"
          />
        </div>
      </div>
    </template>

    <template #content>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header p-3 pb-0">
              <div class="row">
                <div class="col-8 d-flex">
                  <div class="d-flex flex-column justify-content-center"></div>
                </div>
                <div class="col-4">
                  <!--   <span class="badge bg-gradient-primary ms-auto float-end"
                    >Em análise</span
                  > -->
                </div>
              </div>
            </div>
            <div class="card-body p-3 pt-1">
              <div class="row p-4">
                <div class="col-sm-6">
                  <img
                    width="800"
                    height="600"
                    src="/assets/svg/confirmacao_register.svg"
                    alt=""
                    class="img-fluid mx-auto d-block"
                  />
                </div>
                <div class="col-sm-6">
                  <div class="texto mt-5">
                    <!-- <span class="badge bg-gradient-primary">Em análise</span> -->
                    <h3 class="mt-2">Realize a confirmação do seu e-mail</h3>
                    <p class="text lead mt-3 pe-5">
                      Acesse a sua caixa de entrada no seu e-mail e realize a
                      confirmação do seu cadastro
                    </p>

                    <Link
                      as="button"
                      :class="{ disabled: disableButton }"
                      method="post"
                      @click="startTimer"
                      :href="route('verification.send')"
                      class="btn bg-gradient-primary mt-3 ms-auto"
                      >Reenviar confirmação
                      {{ minutesAndSeconds }}
                    </Link>
                  </div>

                  <!--     <div class="d-flex bg-gray-100 border-radius-lg p-3">
                    <h4 class="my-auto">Meu Serviço</h4>
                    <Link
                      :href="route('admin.lojistas.servico')"
                      class="btn btn-outline-dark mb-0 ms-auto"
                      >Abrir</Link
                    >
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </guest-layout>
</template>

  <script>
import GuestLayout from "@/Layouts/GuestLayout";
import { Link } from "@inertiajs/inertia-vue3";
export default {
  components: {
    GuestLayout,
    Link,
  },

  data() {
    return {
      timer: 180, // 3 minutos
      disableButton: false,
    };
  },

  computed: {
    minutesAndSeconds() {
      var minutes = Math.floor(parseInt(this.timer, 10) / 60);
      var seconds = parseInt(this.timer, 10) - minutes * 60;
      //left padseconds
      seconds = seconds < 10 ? "0" + seconds : seconds;

      if (this.disableButton) {
        return `(${minutes}:${seconds})`;
      }
    },
  },

  methods: {
    startTimer() {
      this.disableButton = true;
      let interval = setInterval(() => {
        this.timer--;
        if (this.timer == 0) {
          this.disableButton = false;
          clearInterval(interval);
        }
      }, 1000);
    },
  },
};
</script>

  <style>
</style>
